import { render, staticRenderFns } from "./MealplanDetails.vue?vue&type=template&id=1471de59&scoped=true"
import script from "./MealplanDetails.vue?vue&type=script&lang=js"
export * from "./MealplanDetails.vue?vue&type=script&lang=js"
import style0 from "./MealplanDetails.vue?vue&type=style&index=0&id=1471de59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1471de59",
  null
  
)

export default component.exports